"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScoreTypeToggle = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const iosSwitch_1 = require("./iosSwitch");
const ScoreTypeToggle = ({ scoreFormat, onToggle }) => {
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", spacing: 2, flexWrap: "wrap", useFlexGap: true, justifyContent: 'center', alignItems: 'center', alignContent: 'center', mb: 0.5, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "subtitle2", sx: { width: 'max-content', textAlign: 'center' }, children: "Gross" }), (0, jsx_runtime_1.jsx)(iosSwitch_1.IOSSwitch, { checked: scoreFormat === 'net', onChange: () => {
                    onToggle(scoreFormat === 'net' ? 'gross' : 'net');
                } }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "subtitle2", sx: { width: 'max-content', textAlign: 'center' }, children: "Net" })] }));
};
exports.ScoreTypeToggle = ScoreTypeToggle;
